import { useState } from 'react';
import axios from 'axios';
import { usePubSub } from '@videosdk.live/react-sdk';
import Cookies from 'js-cookie';
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ImagePreviewModal from './ImagePreviewModal';
import { url } from "../../../../../../../../../App";

const CaptureImageListener = ({ localParticipantId, loanID, videoRef }) => {
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const { borrowerData } = useBorrowerContext();
  const fetchedBorrowerDetails = borrowerData.borrower;
  const [previewImage, setPreviewImage] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const { publish } = usePubSub('SNAPSHOT_ADDED');

  // usePubSub('IMAGE_CAPTURE', {
  //   onMessageReceived: (message) => {
  //     if (message.senderId !== localParticipantId) {
  //       handleImageCapture();
  //     }
  //   },
  // });

// const waitForVideoReady = (video) => {
//   return new Promise((resolve, reject) => {
//     if (video.videoWidth > 0 && video.videoHeight > 0) {
//       resolve();
//       return;
//     }

//     const onLoaded = () => {
//       video.removeEventListener("loadedmetadata", onLoaded);
//       resolve();
//     };

//     video.addEventListener("loadedmetadata", onLoaded);

//     setTimeout(() => {
//       video.removeEventListener("loadedmetadata", onLoaded);
//       reject(new Error("Video not ready"));
//     }, 2000);
//   });
// };

// const handleImageCapture = async () => {
//   try {
//     const videoElement = videoRef?.current;

//     if (!videoElement) {
//       throw new Error("Video element not found");
//     }

    
//     await waitForVideoReady(videoElement);

//     const width = videoElement.videoWidth;
//     const height = videoElement.videoHeight;

//     if (!width || !height) {
//       throw new Error("Invalid video dimensions");
//     }

//     const canvas = document.createElement("canvas");
//     canvas.width = width;
//     canvas.height = height;

//     const ctx = canvas.getContext("2d");
//     ctx.drawImage(videoElement, 0, 0, width, height);

//     const base64Data = canvas
//       .toDataURL("image/jpeg", 0.95)
//       .split(",")[1];

//     setPreviewImage(base64Data);
//     setModalOpen(true);

//   } catch (error) {
//     console.error("Image capture failed:", error);
//     toast.error("Camera not ready. Please try again.");
//   }
// };


  const handleApprove = async () => {
    try {
      await axios.post(`${url}/videosdk/upload`, {
        token,
        email,
        borrower_Id: fetchedBorrowerDetails.borrower_uniqueno,
        base64Data: previewImage,
        loan_Id: loanID
      });

      toast.success("Image uploaded successfully!");
      publish(
        "Snapshot image added",
        { persist: false },
        { image: previewImage }
      );
      setModalOpen(false);
      setPreviewImage(null);
    } catch (err) {
      toast.error("Upload failed.");
      console.error(err);
    }
  };

  const handleRetake = async () => {
    setPreviewImage(null);
    setModalOpen(false);
  };

  const handleClose = async () => {
    setPreviewImage(null);
    setModalOpen(false);
  };

  return (
    <>
      <ToastContainer />
      <ImagePreviewModal
        imageSrc={previewImage}
        onApprove={handleApprove}
        onRetake={handleRetake}
        onClose={handleClose}
        open={isModalOpen}
      />
    </>
  );
};

export default CaptureImageListener;